// Port of api/fuel/app/classes/controller/api/monty/groups/create.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import {
	currentUser,
	defaultSlugForUser,
	ensureMembership,
	groupPayload,
	invalid,
	nextGroupId,
	normaliseAvatar,
	persist,
	recountGroupUsers,
	recountUserGroups,
	slugTaken,
	validGroupData
} from './shared'

export default function(params) {
	var user = currentUser(params)
	if (!user) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var data = params.data || {}
	var slug = defaultSlugForUser(data, user)
	var requireSlug = !!user.get_upgrade()

	if (!validGroupData(Object.assign({}, data, { slug: slug }), requireSlug)) return invalid()
	if (slugTaken(slug)) return invalid(Constants.API_ERROR_GROUP_SLUG_TAKEN)

	var now = Math.floor(Date.now() / 1000)
	var groupId = nextGroupId()
	var avatar = normaliseAvatar(data.avatar, '')

	DB.run('INSERT INTO groups (group_id, user_id, group_type, group_membership, group_avatar, group_name, group_slug, group_oldslug, group_date_created, group_date_play_first, group_count_users, group_count_sync, group_count_collection, group_count_collection_games, group_count_collection_expansions, group_count_ratings, group_count_plays, group_count_plays_games, group_count_lists, group_count_daily, group_count_daily_self, group_count_daily_perk, group_count_weekly, group_data_version) VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)', [
		groupId,
		user.get_id(),
		Constants.GROUP_TYPE_STANDARD,
		parseInt(data.membership, 10),
		avatar,
		(data.name || '').trim(),
		slug,
		slug,
		now,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		0,
		now
	])

	ensureMembership(groupId, user.get_id())
	recountGroupUsers(groupId)
	recountUserGroups(user.get_id())

	return persist(groupPayload(groupId))
}
